import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Button, CircularProgress, Switch, FormControlLabel, MenuItem, Select, FormControl, InputLabel, TextField } from "@mui/material";
import { Save } from "lucide-react";
import { useTranslation } from "react-i18next";
const CatalogTab = ({
  settings,
  save,
  saving
}) => {
  const {
    t
  } = useTranslation("website");
  const [form, setForm] = useState({});
  useEffect(() => {
    if (settings) setForm({
      priceVisibility: settings.priceVisibility || "show",
      currencySymbol: settings.currencySymbol || "",
      showOutOfStock: settings.showOutOfStock !== false,
      productsPerPage: settings.productsPerPage || 20,
      enableCart: settings.enableCart !== false
    });
  }, [settings]);
  const set = (key, val) => setForm(f => ({
    ...f,
    [key]: val
  }));
  return <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>{t("Price Visibility")}</InputLabel>
            <Select value={form.priceVisibility || "show"} onChange={e => set("priceVisibility", e.target.value)} label={t("Price Visibility")}>
              <MenuItem value="show">{t("Show Prices")}</MenuItem>
              <MenuItem value="hide">{t("Hide Prices")}</MenuItem>
              <MenuItem value="on_request">{t("Show \"Request Price\"")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField label={t("Currency Symbol")} value={form.currencySymbol || ""} onChange={e => set("currencySymbol", e.target.value)} fullWidth placeholder={t("SAR")} helperText={t("Leave blank to use company default")} />
          
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField label={t("Products Per Page")} type="number" value={form.productsPerPage || 20} onChange={e => set("productsPerPage", Math.max(1, parseInt(e.target.value) || 20))} fullWidth inputProps={{
          min: 4,
          max: 100
        }} />
          
        </Grid>

        <Grid item xs={12} sm={6} sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}>
          <FormControlLabel control={<Switch checked={!!form.showOutOfStock} onChange={e => set("showOutOfStock", e.target.checked)} />} label={t("Show out-of-stock products")} />
          
          <FormControlLabel control={<Switch checked={!!form.enableCart} onChange={e => set("enableCart", e.target.checked)} />} label={t("Enable shopping cart")} />
          
        </Grid>

        {form.priceVisibility === "hide" && <Grid item xs={12}>
            <Typography variant="body2" color="warning.main">{t("Prices will be hidden from all visitors. They can still add items to cart.")}

          </Typography>
          </Grid>}
        {form.priceVisibility === "on_request" && <Grid item xs={12}>
            <Typography variant="body2" color="info.main">{t("A \"Request Price\" label will be shown instead of the actual price.")}

          </Typography>
          </Grid>}

        <Grid item xs={12}>
          <Button variant="contained" onClick={() => save(form)} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : <Save size={16} />}>{t("Save Catalog Settings")}


          </Button>
        </Grid>
      </Grid>
    </Box>;
};
export default CatalogTab;
